var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { omit } from "lodash-es";
import { Component, Mixins } from 'vue-property-decorator';
import devToolMixin from '../../util/devToolMixin';
import JsonView from "../../../../../lib/builtin/components/JSONView";
import Vue from 'vue';
let PayloadPanel = class PayloadPanel extends Mixins(devToolMixin) {
  get selectedData() {
    return (this.events || []).filter(e => this.selectedEvents.includes(e.eid)) || [];
  }
  cleanValue(item) {
    const cleaned = omit(item, ['eid', 'type', 'compInstance', 'renderer']);
    if (item.args[0] instanceof MouseEvent) {
      return {
        ...cleaned,
        args: item.args.slice(1)
      };
    }
    // 有一些自定义传出事件paylaod的，不渲染vue组件示例
    return {
      ...cleaned,
      args: item.args.map(arg => arg instanceof Vue ? 'Vue组件实例' : arg)
    };
    return {
      ...cleaned.args
    };
  }
  highLight(item) {
    this.dtHightLightRect(item.compInstance);
  }
  selectAll(item) {
    this.selectedEvents = this.events.filter(eventInfo => eventInfo.compInstance === item.compInstance).map(info => info.eid);
  }
  jumpToComp(item) {
    const tempStack = [];
    let curRenderer = item.renderer;
    while (curRenderer.parentScope) {
      var _curRenderer$ucScoped;
      tempStack.push(this.findScopeInfo(curRenderer.parentScope, (_curRenderer$ucScoped = curRenderer.ucScopedSlotOwner) === null || _curRenderer$ucScoped === void 0 ? void 0 : _curRenderer$ucScoped.compPath, curRenderer));
      curRenderer = curRenderer.parentScope;
    }
    this.$set(this.bus, 'scopedSlotStack', tempStack);
    this.devToolTabKey = 'layout';
    this.$nextTick(() => {
      this.activeCompPath = item.compPath;
    });
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "class": "ucd-devTool-timeline-payloadPanel"
    }, [this.selectedData.length ? this.selectedData.map(item => h("div", {
      "class": "payloadLine"
    }, [h(JsonView, {
      "attrs": {
        "value": this.cleanValue(item),
        "initKey": 'payload',
        "rootLevelKeys": ['payload', 'args']
      }
    }), h("div", {
      "class": "actionBar"
    }, [h("a-button", {
      "on": {
        "click": () => this.highLight(item)
      },
      "attrs": {
        "type": 'link'
      }
    }, ["\u5728\u9875\u9762\u4E2D\u9AD8\u4EAE"]), h("a-button", {
      "on": {
        "click": () => this.jumpToComp(item)
      },
      "attrs": {
        "type": 'link'
      }
    }, ["\u8DF3\u8F6C\u5230\u7EC4\u4EF6"]), h("a-button", {
      "on": {
        "click": () => this.selectAll(item)
      },
      "attrs": {
        "type": 'link'
      }
    }, ["\u9009\u4E2D\u5F53\u524D\u7EC4\u4EF6\u7684\u6240\u6709\u4E8B\u4EF6"])])])) : h("div", {
      "class": "empty"
    }, [h("div", [" \u8BF7\u5728\u5DE6\u4FA7\u9009\u4E2D\u4E8B\u4EF6\u4EE5\u67E5\u770B\u6570\u636E "]), h("div", [" \u6309\u4F4F shift \u8FDE\u7EED\u591A\u9009 "]), h("div", [" \u6309\u4F4F cmd \u5355\u6761\u591A\u9009 "])])]);
  }
};
PayloadPanel = __decorate([Component({
  name: 'PayloadPanel'
})], PayloadPanel);
export default PayloadPanel;
//# sourceMappingURL=PayloadPanel.js.map
